/**
 * Check if two DOMRect are the same by comparing their properties.
 *
 * @param a one DOMRect object
 * @param b another DOMRect object
 * @returns true if the two DOMRect objects are the same, false otherwise.
 */
export const isSameDOMRect = (a: DOMRect, b: DOMRect): boolean => (
    a.x === b.x &&
    a.y === b.y &&
    a.width === b.width &&
    a.height === b.height &&
    a.top === b.top &&
    a.right === b.right &&
    a.bottom === b.bottom &&
    a.left === b.left
);
